<template>
  <div id="dinning">



    <div class="container" >
      <Title :text="title"></Title>

      <div class="swiper-container" id="dinning-swiper">
        <div class="swiper-wrapper">
        
          <div class="swiper-slide">
            <img src="../../../assets/img/dinning/dinning (2).jpg" alt="">
          </div>
          <div class="swiper-slide">
            <img src="../../../assets/img/dinning/dinning (3).jpg" alt="">
          </div>
            <div class="swiper-slide">
            <img src="../../../assets/img/dinning/dinning (1).jpg" alt="">
          </div>
        </div>
         <div class="swiper-pagination"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Title from "../title/Title2.vue";
import Swiper  from 'swiper'
import WOW from "wowjs";

export default {
  name: "Dinning",
  props: {},
  data() {
    return {
      title: "Restaurant"
    };
  },
  components: {
    Title
  },
  mounted() {
    new WOW.WOW().init();
     new Swiper("#dinning-swiper",{
        autoplay:true,
        mousewheel: true,
         pagination: {
            el: '.swiper-pagination',
            bulletActiveClass: 'my-bullet-active',
            bulletClass : 'my-bullet',
            clickable :true,
          },
    })
  }
};
</script>

<style scoped lang="scss">

#dinning {
  background: url("../../../assets/img/dinning/bg.jpg") no-repeat;
  background-size: 100% 100%;
  background-position: center;
}

#dinning-swiper {
  border-radius: 30px;
  box-shadow: 0 0 20px rgba($color:#000000, $alpha: .7);
  img {
    width: 100%;
    height: 100%;
    display: block;
  }
}



</style>
